import { DeleteEntityDialog } from "@/components/common/delete-entity-dialog";
import { useDeleteCategory } from "@/hooks/services/use-categories";
import type { Category } from "@/types/services/api-types/category-types";

interface DeleteCategoryDialogProps {
  category: Category | null;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function DeleteCategoryDialog({
  category,
  open,
  onOpenChange,
}: DeleteCategoryDialogProps) {
  const deleteCategory = useDeleteCategory();

  return (
    <DeleteEntityDialog
      entity={category}
      open={open}
      onOpenChange={onOpenChange}
      entityName="Category"
      onDelete={async (id) => {
        await deleteCategory.mutateAsync(id);
      }}
      isDeleting={deleteCategory.isPending}
      conflictMessage={`Unable to delete "${category?.name}" while it still contains services.`}
      customDescription={`Are you sure you want to delete "${category?.name}"? This action cannot be undone.`}
    />
  );
}
